const buttonUnv =
  " flex items-center justify-center w-auto  py-[4px] px-[20px] text-white rounded-full shadow-button ";
const redBtn = "bg-blue/80 hover:bg-blue hover:text-black ";
const yellowBtn = "bg-yellow/80  hover:bg-yellow hover:text-black";

export { buttonUnv, redBtn, yellowBtn };
